import moment from 'moment';
import i18n from '@/locales/i18n';

export const formatAppointmentText = (date: string, type: string, stCar: string) => {
  const diffDays = moment().diff(date, 'days');
  const ONE_DAY_BEFORE = -1;

  if (diffDays === ONE_DAY_BEFORE) {
    return i18n.t('appointment_tomorrow', { type }).toString();
  }

  if (diffDays === 0) {
    return i18n.t('appointment_today', { type, stCar }).toString();
  }

  return i18n.t('appointment_days', { type, diffDays: Math.abs(diffDays), stCar }).toString();
};
